import React, { useState } from "react";
import { Icon, Image, Popup, Modal, Header, Button, Grid } from "semantic-ui-react";
import Input from "../../../commonComponents/Input/index"
import DropDown from "../../../commonComponents/dropDownCommon";
import Draggable from 'react-draggable'
import './entryStatusModalStyle.scss'
import { entryNumberEdit, updateShipmentStatus } from "../../../apiCalls/jobTransitionCalls";
import _ from "lodash"
import { entrySummaryStatusMap } from "../../../util/constants";

const EntryStatusModal = ({ shipId, epuData, kxUser, searchByID }) => {
    const [open, setOpen] = React.useState(false);
    const [epu, setEpu] = React.useState(epuData ? epuData : "");
    const [hmrc, setHmrc] = React.useState("");
    const [entryStatusErr, setEntryStatusErr] = React.useState("");
    const [statusErr, setStatusErr] = React.useState("");
    const [entryStatusSuccess, setEntryStatusSuccess] = React.useState("");
    const [statusSuccess, setStatusSuccess] = React.useState("");
    const [date, setDate] = React.useState({date: "", epoch: "", actualValue: ""});
    const [entryDate, setEntryDate] = React.useState("");
    const [status, setStatus] = React.useState("");
    const [mandErr, setMandErr] = React.useState(false);
    const [submitTxt, setSubmitTxt] = React.useState("Submit");

    const statusDropdownVal = [
        // {
        //     id: 1,
        //     stringVal: "ACCEPTED ENTRY ROUTE 0",
        //     description: "ACCEPTED_ENTRY_ROUTE_0"
        // },
        {
            id: 2,
            stringVal: "ACCEPTED ENTRY ROUTE 1 C",
            description: "ACCEPTED_ENTRY_ROUTE_1_C"
        },
        // {
        //     id: 3,
        //     stringVal: "ACCEPTED ENTRY ROUTE 1",
        //     description: "ACCEPTED_ENTRY_ROUTE_1"
        // },
        // {
        //     id:4,
        //     stringVal: "ACCEPTED ENTRY ROUTE 2",
        //     description: "ACCEPTED_ENTRY_ROUTE_2"
        // },
        {
            id:5,
            stringVal: "ACCEPTED ENTRY ROUTE 2 C",
            description: "ACCEPTED_ENTRY_ROUTE_2_C"
        },
        // {
        //     id:6,
        //     stringVal: "ACCEPTED ENTRY ROUTE 3",
        //     description: "ACCEPTED_ENTRY_ROUTE_3"
        // },
        {
            id:7,
            stringVal: "ACCEPTED ENTRY ROUTE 3 C",
            description: "ACCEPTED_ENTRY_ROUTE_3_C"
        },
        // {
        //     id:8,
        //     stringVal: "ACCEPTED ENTRY ROUTE 5",
        //     description: "ACCEPTED_ENTRY_ROUTE_5"
        // },
        // {
        //     id:9,
        //     stringVal: "ACCEPTED ENTRY ROUTE 6",
        //     description: "ACCEPTED_ENTRY_ROUTE_6"
        // },
        {
            id:10,
            stringVal: "ACCEPTED ENTRY ROUTE 6 C",
            description: "ACCEPTED_ENTRY_ROUTE_6_C"
        },
        // {
        //     id:11,
        //     stringVal: "ACCEPTED ENTRY ROUTE E",
        //     description: "ACCEPTED_ENTRY_ROUTE_E"
        // },
        // {
        //     id:12,
        //     stringVal: "ACCEPTED ENTRY ROUTE F",
        //     description: "ACCEPTED_ENTRY_ROUTE_F"
        // },
        // {
        //     id:13,
        //     stringVal: "ACCEPTED ENTRY ROUTE H",
        //     description: "ACCEPTED_ENTRY_ROUTE_H"
        // },
    ]

    const submitHandler = () =>{
        if(!epu || !hmrc || !entryDate || !status){
            setMandErr(true);
            return;
        }
        setMandErr(false);
        setSubmitTxt("Submitting...")
        let eDate = entryDate.split("-").reverse().join("/")
        entryNumberEdit(shipId, epu, hmrc, eDate, date.epoch).then((response) =>{
            let userGuid = _.get(kxUser, "userBasicInfo.userGuid", null);
            updateShipmentStatus(status, shipId, userGuid).then((response2) => {
                setSubmitTxt("Submit")
                if(_.get(response, "data.eventMessage.code") === 200 && _.get(response, "data.eventMessage.msg") === "Data updated successfully"){
                    setEntryStatusSuccess("Data Updated Succesfully!")
                }
                else{
                    setEntryStatusErr("Data Cannot be Updated, Try Again Later!")
                }
            }).catch((err) => {
                setSubmitTxt("Submit")
                setStatusErr("Status Cannot be Updated, Try Again Later!")
            })
            
            setTimeout(() => {
                setEntryStatusSuccess("");
                setEntryStatusErr("");
                setStatusErr("");
                searchByID(shipId)
                setOpen(false);
            }, 3000)
        }).catch((err) => {
            let userGuid = _.get(kxUser, "userBasicInfo.userGuid", null);
            setEntryStatusErr("Entry Number Cannot be Updated, Try Again Later!")
            updateShipmentStatus(status, shipId, userGuid).then((response2) => {
                setSubmitTxt("Submit")
                setStatusSuccess("Status Updated successfully")
            }).catch((err) => {
                setSubmitTxt("Submit")
                setStatusErr("Status Cannot be Updated, Try Again Later!")
            })
            setTimeout(() => {
                setEntryStatusErr("");
                setStatusSuccess("");
                setStatusErr("");
                setOpen(false);
            }, 5000)
        })
    }

    const changeDate = (value) =>{
        setEntryDate(value);
        let epoch;
        let newDate = new Date(Date.UTC((new Date(value)).getFullYear(), (new Date(value)).getMonth(), (new Date(value)).getDate()))
        epoch =newDate.getTime();
        // let day = newDate.getDate();
        // let month = newDate.getMonth() + 1;
        // let year = newDate.getFullYear();
        // if(day < 10){
        //     day = "0" + day;
        // }
        // if(month < 10){
        //     month = "0" + month;
        // }
        // let date = day + "/" + month + "/" + year
        setDate({date:"", epoch:epoch, actualValue:""})
    }
    const entryMaxDate = () => {
        let date = new Date()
        const offset = date.getTimezoneOffset()
        date = new Date(date.getTime() - (offset*60*1000))
        return date.toISOString().split('T')[0]
    }

    return ( 
        <Draggable
            handle=".header"
        >
            <Modal
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                trigger={<Icon id="entryname-icon" name="edit" className="edit-icon" />}
            >
                <Modal.Header className="entry-modal-header">Edit Entry Number and Status for {shipId}</Modal.Header>
                <Modal.Content className="entry-status-modal-content">
                    {entryStatusErr && <div className="error-div">
                        <h5>{entryStatusErr}</h5>
                    </div>}
                    {statusErr && <div className="error-div">
                        <h5>{statusErr}</h5>
                    </div>}
                    {entryStatusSuccess && <div className="success-div">
                        <h5>{entryStatusSuccess}</h5>
                    </div>}
                    {statusSuccess && <div className="success-div">
                        <h5>{statusSuccess}</h5>
                    </div>}
                    {mandErr && <div className="mand-error-div">
                        <h5>* All Fields are Mandatory</h5>
                    </div>}
                    <Grid>
                        <Grid.Row className="entry-number-row">
                            <h4 className="minus-icon">Entry Number:</h4>
                            <Grid.Column computer={4}>
                                <Input 
                                    placeholder="EPU"
                                    value={epu}
                                    onChange={(value) => setEpu(value)}
                                ></Input>
                            </Grid.Column>
                            <Icon name="minus" className="minus-icon"/>
                            <Grid.Column computer={4}>
                                <Input 
                                    placeholder="HMRC Entry Number"
                                    value={hmrc.toUpperCase()} 
                                    onChange={(value) => setHmrc(value.toUpperCase())}
                                ></Input>
                            </Grid.Column>
                            <Icon name="minus" className="minus-icon"/>
                            <Grid.Column computer={4}>   
                            <input type="date" name="entryDate" 
                                min="2010-01-01" 
                                max={entryMaxDate()}
                                onChange={(e)=>{
                                    let dateValue = e.target.value;
                                    changeDate(dateValue)
                                }}
                                style={{"height": "39px"}}
                            required pattern="\d{2}-\d{2}-\d{4}" />
                                {/* <Input 
                                    placeholder="Date"
                                    value={date.actualValue}
                                    onChange={(e, value) => changeDate(e, value)}
                                    pattern={"[0-9]{4}-[0-9]{2}-[0-9]{2}"}
                                    type="date"
                                ></Input> */}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="status-row">
                            <h4 className="minus-icon">Status:</h4>
                            <Grid.Column computer={6}>
                                <DropDown
                                    style={{"borderColor": "#1765AE"}}
                                    type="text"
                                    id='status'
                                    className="status-dropdown"
                                    data={statusDropdownVal}
                                    text={status ? status.replaceAll("_", " ") : "Select"}
                                    onChange={(value) => setStatus(value.replaceAll(" ", "_"))}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button color="blue" onClick={() => setOpen(false)}>
                        Cancel
                    </Button>
                    <Button positive onClick={() => submitHandler()}>
                        {submitTxt}
                    </Button>
                </Modal.Actions>
                
            </Modal>
        </Draggable>
    );
}
 
export default EntryStatusModal;